import { render } from "./DynamicCollapseForApproval.vue?vue&type=template&id=64c9875c&scoped=true"
import script from "./DynamicCollapseForApproval.vue?vue&type=script&lang=ts"
export * from "./DynamicCollapseForApproval.vue?vue&type=script&lang=ts"

import "./DynamicCollapseForApproval.vue?vue&type=style&index=0&id=64c9875c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64c9875c"

export default script